module.exports = __webpack_public_path__ + "static/media/delivery-takeout.7fd81652.svg";